import React, { useEffect, useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../HandleAPICalls/actions";
import AgentRoster from "./Component";

const Cst_Rooster_Container = (props) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [agentData, setAgentData] = useState(null);
  const [statusFilter, setStatusFilter] = useState('All');
  
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    type: null,
    items: []
  });
  const [successPopup, setSuccessPopup] = useState({
    show: false,
    message: ''
  });
  
  const isDeletingRef = useRef(false);
  const modalCloseTimerRef = useRef(null);

  const Rooster_list = useCallback(() => {
    setLoading(true);
    setError(null);
    
    let url = "/partner/api/v1/whatsapp/agent-schedule";
    if (statusFilter === 'Active This Week') {
      url += "?weekType=current";
    }
    
    props.getDataFromAPI(
      url,
      "GET",
      undefined,
      (response) => {
        setAgentData(response);
        setLoading(false);
        setSelectedRows([]);
      },
      (error) => {
        setError("Failed to fetch agent roster");
        setLoading(false);
      }
    );
  }, [statusFilter, props]);

  const handleStatusFilterChange = useCallback((filter) => {
    setStatusFilter(filter);
    setSelectedRows([]);
  }, []);

  useEffect(() => {
    Rooster_list();
  }, [Rooster_list]);

  const handleRowSelection = useCallback((row, isSelected) => {
    setSelectedRows(prev => {
      if (isSelected) {
        return [...prev, row];
      } else {
        return prev.filter(selected => selected.id !== row.id);
      }
    });
  }, []);

  const handleSelectAll = useCallback((isSelected, filteredData) => {
    if (isSelected) {
      setSelectedRows([...filteredData]);
    } else {
      setSelectedRows([]);
    }
  }, []);

  // Smooth delete click - No visible state change
  const handleDeleteClick = useCallback((row) => {
    // Clear any pending timer
    if (modalCloseTimerRef.current) {
      clearTimeout(modalCloseTimerRef.current);
    }
    
    setDeleteModal({
      show: true,
      type: 'single',
      items: [row]
    });
  }, []);

  const handleBulkDeleteClick = useCallback(() => {
    if (selectedRows.length === 0) return;
    
    if (modalCloseTimerRef.current) {
      clearTimeout(modalCloseTimerRef.current);
    }
    
    setDeleteModal({
      show: true,
      type: 'bulk',
      items: selectedRows
    });
  }, [selectedRows]);

  // Smooth confirm delete - Instant close, no blink
  const handleConfirmDelete = useCallback(async () => {
    if (isDeletingRef.current) return;
    
    isDeletingRef.current = true;
    
    // IMMEDIATELY close modal - no delay, no blink
    setDeleteModal({ show: false, type: null, items: [] });
    
    // Show loading on the delete button only, not full page
    setLoading(true);
    
    try {
      const itemsToDelete = deleteModal.items;
      const idsToDelete = itemsToDelete.map(item => item.id);
      
      const payload = { ids: idsToDelete };
      
      await new Promise((resolve, reject) => {
        props.getDataFromAPI(
          "/partner/delete/agent",
          "DELETE",
          payload,
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
      
      // Show success message
      setSuccessPopup({
        show: true,
        message: `Successfully deleted ${itemsToDelete.length} schedule${itemsToDelete.length > 1 ? 's' : ''}`
      });
      
      setSelectedRows([]);
      
      // Refresh data in background
      setTimeout(() => {
        Rooster_list();
      }, 500);
      
    } catch (error) {
      setError("Failed to delete selected schedules");
    } finally {
      setLoading(false);
      setTimeout(() => {
        isDeletingRef.current = false;
      }, 300);
    }
  }, [deleteModal, props, Rooster_list]);

  const handleCloseDeleteModal = useCallback(() => {
    if (modalCloseTimerRef.current) {
      clearTimeout(modalCloseTimerRef.current);
    }
    setDeleteModal({ show: false, type: null, items: [] });
  }, []);

  const handleCloseSuccessPopup = useCallback(() => {
    setSuccessPopup({ show: false, message: '' });
  }, []);

  const handleStatusUpdate = useCallback((ids, isActive) => {
    setLoading(true);
    
    const payload = { ids: ids, isActive: isActive };
    
    props.getDataFromAPI(
      "/partner/api/v1/whatsapp/update/status",
      "PUT",
      payload,
      (response) => {
        setLoading(false);
        setOpen(false);
        setSuccessPopup({
          show: true,
          message: `Status updated successfully`
        });
        setTimeout(() => {
          Rooster_list();
        }, 500);
      },
      (error) => {
        setLoading(false);
        setError("Failed to update status");
      }
    );
  }, [props, Rooster_list]);

  const update_roster = useCallback((e, input) => {
    const isActive = input.status === "Active" ? false : true;
    handleStatusUpdate([input.id], isActive);
  }, [handleStatusUpdate]);

  const refreshData = useCallback(() => {
    Rooster_list();
  }, [Rooster_list]);

  return (
    <AgentRoster
      rawAgentData={agentData}
      update_roster={update_roster}
      setOpen={setOpen}
      open={open}
      statusFilter={statusFilter}
      onStatusFilterChange={handleStatusFilterChange}
      onRefresh={refreshData}
      loading={loading}
      error={error}
      setError={setError}
      selectedRows={selectedRows}
      onRowSelection={handleRowSelection}
      onSelectAll={handleSelectAll}
      onDeleteClick={handleDeleteClick}
      onBulkDeleteClick={handleBulkDeleteClick}
      onConfirmDelete={handleConfirmDelete}
      onCloseDeleteModal={handleCloseDeleteModal}
      deleteModal={deleteModal}
      successPopup={successPopup}
      onCloseSuccessPopup={handleCloseSuccessPopup}
    />
  );
};

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(Cst_Rooster_Container);